import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import SecondaryButton from '../components/SecondaryButton/SecondaryButton';
import { ClassroomType, AddStudentModeType } from '../../peekapak-types/DataProtocolTypes';

interface Props {
  classroom: ClassroomType;
  onClassCodeEmail: () => void;
  buttonClass?: string;
}

const ClassCodeButtons = (props: Props) => (
  <>
    {props.classroom &&
      props.classroom.addStudentMode &&
      props.classroom.addStudentMode === AddStudentModeType.CLASS_CODE && (
        <>
          {props.primary ? (
            <PrimaryButton small onClick={props.onClassCodeEmail} className={props.buttonClass}>
              Class Code Invite
            </PrimaryButton>
          ) : (
            <SecondaryButton small onClick={props.onClassCodeEmail} className={props.buttonClass}>
              Class Code Invite
            </SecondaryButton>
          )}
        </>
      )}
  </>
);

export default ClassCodeButtons;
